import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'

class OfferQuotationApprovalService {
  constructor() {
    this.resource = API_RESOURCE.OFFER
  }

  inviteQuotationUser = async ({ offerId, approverIndex, ...data }) => {
    const response = await axios.post(
      `${this.resource}/${offerId}/quotation/approval/${approverIndex}/invitation`,
      data
    )
    return response.data
  }

  replyQuotationInvitation = async ({ offerId, approverIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/quotation/approval/${approverIndex}/invitation/reply`,
      data
    )
    return response.data
  }

  deleteQuotationInvitedUsers = async ({ offerId, approverIndex, ...data }) => {
    const response = await axios.delete(
      `${this.resource}/${offerId}/quotation/approval/${approverIndex}/invitation/batch`,
      {
        data,
      }
    )
    return response.data
  }
}

export default OfferQuotationApprovalService
